import React, { useEffect, useState, useContext, useMemo } from "react";
import CardComponent from "../atoms/CardComponent";
import Stack from "@mui/material/Stack";
import { StackedBar } from "../atoms/StackedBar";
import useUser from "../../hooks/useUser";
import DoughnutChart from "../atoms/DoughnutChart";
import useUtils from "../../utils/useUtils";
import ListAgents from "../atoms/ListAgents";
import useWexClient from "../../hooks/Clients/wexClient,";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../Auth/Context";
import TextField from "@mui/material/TextField";
import { debounce } from "lodash";
import { socketWex } from "../../utils/Socket";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Avatar,
  IconButton,
} from "@mui/material";
import { Height, PushPin, PushPinOutlined } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import { set } from "date-fns";
import MuiModal from "../atoms/MuiModal";
import ButtonComponent from "../atoms/ButtonComponent";
import MobileCallModal from "./MobileCallModal";
import AlertComponent from "../atoms/Alert";
import AvaibleImg from "../../assets/DashboardGeneral/Avaible.png";
import BusyImg from "../../assets/DashboardGeneral/Busy.png";
import OnAttentionImg from "../../assets/DashboardGeneral/OnAttention.png";
import OnRouteImg from "../../assets/DashboardGeneral/OnRoute.png";

// Helper para dar formato a las fechas de forma segura
const formatAvailableAt = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "N/A";

  const day = String(date.getDate()).padStart(2, "0");
  const months = [
    "ENE",
    "FEB",
    "MAR",
    "ABR",
    "MAY",
    "JUN",
    "JUL",
    "AGO",
    "SEP",
    "OCT",
    "NOV",
    "DIC",
  ];
  const month = months[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

function DashboardGeneral(props) {
  const { payload } = useContext(AuthContext);
  const { t } = useTranslation();
  const { selectedOption = "", permissions = {} } = props;

  // Permisos de llamadas
  const callsEnabled = permissions?.callsWeb?.enabled === true;
  const canCallWebDesktop = permissions?.callsWeb?.outbound?.webDesktop === true;
  const canCallWebPhone = permissions?.callsWeb?.outbound?.webPhone === true;
  //const callWex = process.env.REACT_APP_GINA_CALL_URL;
  const {
    getInfoAgents,
    disconnectAgents,
    getServices,
    closeAllFolios,
    markedAdjusters,
  } = useWexClient();
  const [combinedData, setCombinedData] = useState(null);
  const { colorHEX } = useUtils();
  const { countUserByStatus, countAllAgents } = useUser();
  const [dataStatusBarChar, setDataStatusBarChar] = useState();
  const [setDataBarChar] = useState([]);
  const [setLabelsReport] = useState([]);
  const [rows, setRows] = useState([]);
  // llamada
  const [idCabin, setIdCabin] = useState();
  const [callData, setCallData] = useState({ from: "", to: "" });
  // Helper to normalize text
  function normalize(text = "") {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  const statusOrder = {
    disponible: 0,
    "en ruta": 1,
    atencion: 2,
    "no disponible": 3,
  };

  function getStatusOrder(status) {
    const key = normalize(status);
    return statusOrder[key] ?? 99;
  }

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [callModalOpen, setCallModalOpen] = useState(false);
  const [callAgent, setCallAgent] = useState(null);
  const [modalAlert, setModalAlert] = useState({ show: false, message: "" });

  const displayedData = useMemo(() => {
    if (!combinedData) return [];
    let data = combinedData;
    if (statusFilter) {
      data = data.filter((item) => item.status?.toLowerCase() === statusFilter);
    }
    if (searchTerm) {
      const term = normalize(searchTerm);
      data = data.filter(
        (item) =>
          normalize(item.alias || "").includes(term) ||
          normalize(item.name || "").includes(term),
      );
    }
    data = data
      .slice()
      .sort((a, b) => getStatusOrder(a.status) - getStatusOrder(b.status));
    return data;
  }, [combinedData, statusFilter, searchTerm]);

  // Debounced handler to avoid excessive renders
  const handleSearchChange = debounce((e) => {
    setSearchTerm(e.target.value);
  }, 300);

  // Status colors map (same as in ListAgents)
  const statusColors = {
    disponible: "#4CAF50",
    "en ruta": "#6024c7",
    atencion: "#b78804",
    "no disponible": "#1371b5",
  };

  //Status
  const [agentsAvailable, setAgentsAvailable] = useState(0);
  const [agentsConnect, setAgentsConnect] = useState(0);
  const [agentsOnRoute, setAgentsOnRoute] = useState(0);
  const [agentsDisconnect, setAgentsDisconnect] = useState(0);
  const [agentsOnAttention, setAgentsOnAttention] = useState(0);

  const getDataForDoghnut = (array = []) => {
    const data = array.map((item) => item.count);
    const labels = array.map((item) => item._id);
    const colors = array.map((e) => colorHEX());

    const dataChar = {
      label: labels,
      data: data,
      borderColor: colors,
      backgroundColor: colors,
    };

    const dataGraph = {
      labels: labels,
      datasets: [dataChar],
      borderWidth: 1,
    };

    if (labels.length <= 0 || data.length <= 0) {
      setDataStatusBarChar({ datasets: [] });
      return;
    }
    if (dataStatusBarChar === dataGraph) return;
    else {
      setDataStatusBarChar(dataGraph);
    }
  };

  useEffect(() => {
    if (!selectedOption) return;
    socketWex.emit("info-dashboard", {
      serviceId: selectedOption,
      regionIds: payload?.regionIds,
      rol: payload.profile.class,
    });

    const joinCallUsers = () => {
      socketWex.emit("join-user-calls", { idUser: payload._id }, (response) => {
        if (!response?.success) {
          console.error("Error al unirse a call users:", response?.message);
        } else {
          console.log("Join call users exitoso");
        }
      });
    };

    const handleSocketDisconnect = (reason) => {
      console.warn("Socket desconectado:", reason);
    };
    const intervalId = setInterval(() => {
      socketWex.emit("info-dashboard", {
        serviceId: selectedOption,
        regionIds: payload?.regionIds,
        rol: payload.profile.class,
      });
    }, 10000);

    const handleCallStart = (data) => {
      console.log("Llamada iniciada:", data);
    };
    const handleCallEnd = (data) => {
      console.log("Llamada finalizada:", data);
      clearCallSelection();
    };

    socketWex.on("data-dashboard", (data) => {
      //console.log(JSON.stringify(data.dataAgent, null, 2));
      const { agents } = data;

      const statusDisponible =
        data?.statusAgents?.find((s) => s._id?.toLowerCase() === "disponible")
          ?.count ?? 0;

      const statusConectado =
        data?.statusAgents?.find((s) => s._id?.toLowerCase() === "conectado")
          ?.count ?? 0;

      const statusAtencion =
        data?.statusAgents?.find((s) => s._id?.toLowerCase() === "atencion")
          ?.count ?? 0;

      const statusOffline =
        data?.statusAgents?.find((s) => s._id?.toLowerCase() === "offline")
          ?.count ?? 0;

      const statusOnRoute =
        data?.statusAgents?.find((s) => s._id?.toLowerCase() === "en ruta")
          ?.count ?? 0;

      setAgentsAvailable(statusDisponible);
      setAgentsConnect(statusConectado);
      setAgentsOnRoute(statusOnRoute);
      setAgentsDisconnect(statusOffline);
      setAgentsOnAttention(statusAtencion);

      // 👇 esto sí lo mantienes
      getDataForDoghnut(data?.statusAgents);

      const dataAgents =
        data?.dataAgent?.map((item) => ({
          _id: item?.agent?._id,
          name: item?.agent?.profile?.name,
          alias: item?.agent?.profile?.alias,
          queue: item?.agent?.queue?.[0],
          status:
            item?.status?.toLowerCase() === "conectado"
              ? "No Disponible"
              : item?.status,
          availableAt: item?.availableAt,
          lastIncidentClosedAt: item?.lastIncidentClosedAt,
        })) || [];

      setCombinedData(dataAgents);

      const rows = Object.entries(agents || {}).map(([name, info]) => ({
        name,
        count: info?.mensajes?.enEspera ?? 0,
      }));

      setRows(rows);
    });
    socketWex.on("connect", joinCallUsers);
    socketWex.on("disconnect", handleSocketDisconnect);
    socketWex.on("user-call-started", handleCallStart);
    socketWex.on("user-call-ended", handleCallEnd);
    if (socketWex.connected) {
      joinCallUsers();
    } else {
      socketWex.connect();
    }
    return () => {
      clearInterval(intervalId);
      socketWex.off("connect", joinCallUsers);
      socketWex.off("disconnect", handleSocketDisconnect);
      socketWex.off("data-dashboard");
      socketWex.off("user-call-started", handleCallStart);
      socketWex.off("user-call-ended", handleCallEnd);
    };
  }, [selectedOption, payload]);
  /***
   *    TABLA DE AGENTES
   *
   */

  useEffect(() => {
    if (!payload) return;
    setIdCabin(payload._id);
  }, [payload]);

  const clearCallSelection = () => {
    setCallModalOpen(false);
    setCallAgent(null);
    setSelectedAgent(null);
    setModalOpen(false);
  };

  const handleCallHere = () => {
    if (!selectedAgent) return;

    const body = {
      cabinId: payload._id,
      agentId: selectedAgent._id,
      serviceId: payload?.service,
      isUserCabin: true,
    };

    markedAdjusters(body)
      .then((response) => {
        if (response?.success) {
          const { from, to } = response.data;
          setCallData({ from, to });

          // Mostrar alerta de éxito en el modal y ocultar botones
          setModalAlert({
            show: true,
            message: response.message || "Llamada iniciada correctamente",
          });

          // Cerrar el modal después de 3 segundos y abrir MobileCallModal
          setTimeout(() => {
            setModalAlert({ show: false, message: "" });
            setSelectedAgent(null);
            setModalOpen(false);

            // Abrir el MobileCallModal
            setCallAgent({
              _id: idCabin,
              name: selectedAgent.alias || selectedAgent.name,
              from,
              to,
            });
            setCallModalOpen(true);
          }, 3000);
        } else {
          setModalAlert({
            show: true,
            message: response?.message || "Error al iniciar la llamada",
          });
        }
      })
      .catch((error) => {
        console.error("Error en la petición:", error);
        setModalAlert({ show: true, message: "Error en la petición" });
      });
  };

  const handleCallMobile = () => {
    if (!selectedAgent) return;

    const body = {
      cabinId: payload._id,
      agentId: selectedAgent._id,
      serviceId: payload?.service,
    };

    markedAdjusters(body)
      .then((response) => {
        if (response?.success) {
          const { from, to } = response.data;
          setCallData({ from, to });
          console.log("Llamada móvil iniciada - From:", from, "To:", to);

          // Mostrar alerta de éxito en el modal y ocultar botones
          setModalAlert({
            show: true,
            message: response.message || "Llamada móvil iniciada correctamente",
          });

          // Cerrar el modal después de 3 segundos
          setTimeout(() => {
            setModalAlert({ show: false, message: "" });
            setSelectedAgent(null);
            setModalOpen(false);
          }, 3000);
        } else {
          setModalAlert({
            show: true,
            message: response?.message || "Error al iniciar la llamada",
          });
        }
      })
      .catch((error) => {
        console.error("Error en la petición:", error);
        setModalAlert({ show: true, message: "Error en la petición" });
      });
  };

  const CallsButtons = () => {
    if (modalAlert.show) {
      return (
        <Stack
          direction="column"
          spacing={2}
          justifyContent="center"
          width="100%"
        >
          <AlertComponent
            message={modalAlert.message}
            typeAlert="success"
            handleClose={() => setModalAlert({ show: false, message: "" })}
          />
        </Stack>
      );
    }

    return (
      <Stack
        direction="column"
        spacing={2}
        justifyContent="center"
        width="100%"
      >
        {canCallWebDesktop && (
          <Stack justifyContent="center" alignItems="center">
            <ButtonComponent
              label="Llamar Aqui"
              onClick={handleCallHere}
              backgroundColor="#9a2edb"
              color="white"
              width="70%"
              icon={<PhoneIcon />}
            />
          </Stack>
        )}
        {canCallWebPhone && (
          <Stack justifyContent="center" alignItems="center">
            <ButtonComponent
              label="Llamar en Movil"
              onClick={handleCallMobile}
              backgroundColor="#1976d2"
              color="white"
              width="70%"
              icon={<PhoneIcon />}
            />
          </Stack>
        )}
      </Stack>
    );
  };

  const headers = [
    " Acciones ",
    "Estado",
    "Ajustador",
    "Disponible desde",
    "Última finalización",
  ];

  // Componente de celda mapeado por Header
  const cellComponent = (agentItem, header) => {
    const textStyle = {
      fontWeight: 300,
      fontFamily: "Raleway, sans-serif",
      fontSize: "0.9rem",
    };

    switch (header) {
      case " Acciones ":
        return (
          <div
            style={{ ...textStyle, display: "flex", justifyContent: "center" }}
          >
            <IconButton
              size="small"
              onClick={() => {
                if (callsEnabled) {
                  setSelectedAgent(agentItem);
                  setModalOpen(true);
                }
              }}
              disabled={!callsEnabled}
              sx={{ p: 0.5 }}
            >
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  fontSize: "0.85rem",
                  bgcolor:
                    statusColors[agentItem.status?.toLowerCase()] || "#9e9e9e",
                  cursor: callsEnabled ? "pointer" : "default",
                  opacity: callsEnabled ? 1 : 0.5,
                }}
              />
            </IconButton>
          </div>
        );

      case "Estado":
        return <div style={textStyle}>{agentItem.status || "Sin estado"}</div>;

      case "Ajustador":
        return (
          <div style={textStyle}>
            {agentItem.alias || agentItem.name || "Sin nombre"}
          </div>
        );

      case "Disponible desde":
        return (
          <div style={textStyle}>
            {formatAvailableAt(agentItem.availableAt)}
          </div>
        );

      case "Última finalización":
        return (
          <div style={textStyle}>
            {formatAvailableAt(agentItem.lastIncidentClosedAt)}
          </div>
        );

      default:
        return null;
    }
  };

  const totalAgents =
    (agentsAvailable ?? 0) +
    (agentsConnect ?? 0) +
    (agentsOnRoute ?? 0) +
    (agentsOnAttention ?? 0);

  return (
    <Stack
      direction="column"
      useFlexGap
      flexWrap="wrap"
      alignItems="flex-start"
      spacing={2}
    >
      <Stack direction="column" sx={{ width: "100%" }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={{
            alignContent: "space-between",
            width: "100%",
            marginTop: "1rem",
          }}
        >
          <CardComponent
            sxCard={{
              marginRight: { xs: "0rem", md: "1rem" },
              marginBottom: { xs: "1rem", md: "0rem" },
              width: { xs: "100%", md: "50%" },
            }}
            title={"Ajustadores Disponibles"}
            count={agentsAvailable ?? 0}
            image={AvaibleImg}
          />
          <CardComponent
            sxCard={{
              marginRight: { xs: "0rem", md: "1rem" },
              width: { xs: "100%", md: "50%" },
            }}
            title={"Ajustadores No Disponibles"}
            count={agentsConnect ?? 0}
            image={BusyImg}
          />
        </Stack>

        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={{
            alignContent: "space-between",
            marginTop: "1rem",
            width: "100%",
          }}
        >
          <CardComponent
            sxCard={{
              marginRight: { xs: "0rem", md: "1rem" },
              marginBottom: { xs: "1rem", md: "0rem" },
              width: { xs: "100%", md: "50%" },
            }}
            title={t("Welcome.text299")}
            count={agentsOnRoute ?? 0}
            image={OnRouteImg}
          />
          <CardComponent
            sxCard={{
              marginRight: { xs: "0rem", md: "1rem" },
              width: { xs: "100%", md: "50%" },
            }}
            title={t("Welcome.text203")}
            count={agentsOnAttention ?? 0}
            image={OnAttentionImg}
          />
        </Stack>
      </Stack>

      <Stack display="column" spacing={2} sx={{ width: "99%" }}>
        <Stack spacing={2}>
          <CardComponent
            sxCard={{ width: { xs: "100%", md: "97%" } }}
            title={"AJUSTADORES: " + " " + (totalAgents ?? 0)}
            content={t("Welcome.text207")}
          >
            <Box
              sx={{
                minWidth: "max-content",
                display: "flex",
                alignItems: "center",
                gap: 1,
                marginBottom: 2,
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 150 }}
              >
                <InputLabel id="status-filter-label">Estado</InputLabel>
                <Select
                  labelId="status-filter-label"
                  id="status-filter"
                  value={statusFilter}
                  label="Estado"
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Todos</em>
                  </MenuItem>
                  {Object.keys(statusColors).map((key) => (
                    <MenuItem key={key} value={key}>
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                size="small"
                variant="outlined"
                placeholder={t("Buscar ajustador")}
                onChange={handleSearchChange}
                sx={{ width: 400, backgroundColor: "#fff" }}
              />
            </Box>

            {combinedData && combinedData.length > 0 && (
              <Box
                sx={{
                  marginTop: "1rem",
                  height: 350, // Límite de altura para activar el scroll
                  overflow: "hidden", // El scroll lo maneja TableContainer dentro de ListAgents
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                  position: "relative",
                  "&::-webkit-scrollbar": {
                    height: "10px",
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#999",
                    borderRadius: "4px",
                    "&:hover": {
                      backgroundColor: "#666",
                    },
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f0f0f0",
                  },
                  scrollbarWidth: "thin",
                  scrollbarColor: "#999 #f0f0f0",
                }}
              >
                {/* Render directo de ListAgents sin wrappers intermediarios con overflow o flex box extra */}
                <ListAgents
                  headers={headers}
                  data={displayedData}
                  cellComponent={cellComponent}
                />
              </Box>
            )}
          </CardComponent>
        </Stack>
      </Stack>

      <MobileCallModal
        open={callModalOpen}
        onClose={() => {
          clearCallSelection();
        }}
        agentData={callAgent}
        payload={payload}
      />

      {/* Modal de acciones del agente */}
      <MuiModal
        visible={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setSelectedAgent(null);
          setModalAlert({ show: false, message: "" });
        }}
        title={selectedAgent?.alias || selectedAgent?.name || "Agente"}
        subtitle={selectedAgent?.status || ""}
        width={360}
        buttons={<CallsButtons />}
      >
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Avatar
            sx={{
              width: 64,
              height: 64,
              fontSize: "1.8rem",
              bgcolor:
                statusColors[selectedAgent?.status?.toLowerCase()] || "#9e9e9e",
              margin: "0 auto 1rem",
            }}
          >
            {(selectedAgent?.alias || selectedAgent?.name || "?")
              .charAt(0)
              .toUpperCase()}
          </Avatar>
          <Typography
            sx={{
              fontFamily: "Raleway, sans-serif",
              fontWeight: 600,
              fontSize: "1.1rem",
            }}
          >
            {selectedAgent?.alias || selectedAgent?.name || "Sin nombre"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Raleway, sans-serif",
              fontWeight: 300,
              fontSize: "0.85rem",
              color: "#666",
              mt: 0.5,
            }}
          >
            {selectedAgent?.status || "Sin estado"}
          </Typography>
        </Box>
      </MuiModal>
    </Stack>
  );
}

export default DashboardGeneral;
